
<!-- -->
<link rel="preconnect" href="https://d3cd5omdchfki3.cloudfront.net">
<ng-template #template>
    <app-offer-photo-gallery [offer]="this.offer" [modalRef]="modalRef"></app-offer-photo-gallery>
</ng-template>
<div *ngIf="offer">
    <div style="overflow: hidden !important; border-radius: 5px !important;" class="box" [ngClass]="this.responsiveStyle({ 'vertical': 'box-handset', 'horizontal': 'box-desktop'})">
        <div style="border-radius: 5px !important;" 
             class="image-hotel-background" 
             [ngClass]="this.responsiveStyle({ 'vertical': 'image-hotel-background-handset', 'horizontal': 'image-hotel-background-desktop'})"                  
            [ngStyle]="{'background-image': 'url(' + offer.amenities.room_photo_urls[imageIndex] + ')'}">
            <div style="border-radius: 5px !important;" 
            class="image-hotel-backdrop" [ngClass]="this.responsiveStyle({ 'vertical': 'image-hotel-backdrop-handset', 'horizontal': ''})"
            >                        
            </div>
        </div>
        <!-- (click)="openModal(template, i)" -->
        <!-- <div style="border-radius: 5px !important; width: 100%; height: 200px; text-align:center;margin:0; padding:0; overflow: hidden !important; ">
            <ng-image-slider #nav
              [images]="imageObject"
              [infinite]="true"
              [imagePopup]="false"
              [imageSize]="{width: '100% !important', height: 169}"
              [arrowKeyMove]="false"
              (imageClick)="openModal(template)"
              (arrowClick)="changeImage($event)"
              slideImage="1"
              class="image-hotel" 
              [ngClass]="this.responsiveStyle({ 'vertical': 'image-hotel-handset', 'horizontal': 'image-hotel-desktop'})" 
              style="margin-left: -1.85px; object-fit: cover;" 
              ></ng-image-slider>
              <div class="ribbon-red" [hidden]="index != 0">
                <div class="txt-red">Popular</div>
            </div>
        </div> -->

        <div (click)="openModal(template)">                    
            <img class="image-hotel" [ngClass]="this.responsiveStyle({ 'vertical': 'image-hotel-handset', 'horizontal': 'image-hotel-desktop'})" style="object-fit: cover;" 
                [ngSrc]="offer.amenities.room_photo_url" fill priority>
            <div class="ribbon-red" [hidden]="index != 0">
                <div class="txt-red">Popular</div>
            </div>
        </div>
    </div>
</div>

